<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.17518 0.692901C6.5606 0.822387 5.9819 1.15307 4.82451 1.81444L4.22461 2.15724L4.22461 2.15724C3.05014 2.82837 2.46291 3.16393 2.03568 3.63545C1.65769 4.05263 1.37201 4.5449 1.19734 5.08007C0.999908 5.68494 0.999908 6.36129 0.999908 7.71399V8.28587C0.999908 9.63857 0.999908 10.3149 1.19734 10.9198C1.37201 11.455 1.65769 11.9472 2.03568 12.3644C2.46291 12.8359 3.05014 13.1715 4.22461 13.8426L4.8247 14.1855C5.98203 14.8469 6.56069 15.1775 7.17524 15.307C7.71904 15.4216 8.28075 15.4216 8.82455 15.307C9.43911 15.1776 10.0178 14.8469 11.1751 14.1856L11.1751 14.1856L11.775 13.8428C12.9496 13.1717 13.5368 12.8362 13.9641 12.3646C14.3421 11.9475 14.6278 11.4552 14.8025 10.92C14.9999 10.3151 14.9999 9.63874 14.9999 8.286V7.71413C14.9999 6.36147 14.9999 5.68514 14.8025 5.08028C14.6278 4.54512 14.3422 4.05286 13.9642 3.63568C13.537 3.16417 12.9498 2.8286 11.7753 2.15746L11.1752 1.81452C10.0178 1.15312 9.43916 0.822421 8.82458 0.692921C8.28075 0.578329 7.71901 0.578322 7.17518 0.692901ZM7.99991 10.7499C9.51869 10.7499 10.7499 9.5187 10.7499 7.99992C10.7499 6.48113 9.51869 5.24992 7.99991 5.24992C6.48113 5.24992 5.24991 6.48113 5.24991 7.99992C5.24991 9.5187 6.48113 10.7499 7.99991 10.7499Z"
    fill="currentColor"
  />
</svg>
